/* eslint-disable import/no-anonymous-default-export */
import {
    BulkDeleteButton,
    Datagrid,
    TextField,
    useListContext,
} from 'react-admin';
import { ContractorOwner } from '@/types';

export const ContractorOwnerListContent = () => {
    const { error } = useListContext<ContractorOwner>();
    if (error) {
        return null;
    }

    return (
        <Datagrid
            rowClick="show"
            bulkActionButtons={<BulkDeleteButton />}
            empty={<span>No contractors found</span>}
            sx={{
                '& .RaDatagrid-rowCell': {
                    py: 1.5,
                },
            }}
        >
            <TextField source="name" />
            <TextField source="email" />
            <TextField source="phone_number" />
        </Datagrid>
    );
};
